import { render, staticRenderFns } from "./IcoSpace.vue?vue&type=template&id=4a1c4841"
import script from "./IcoSpace.vue?vue&type=script&lang=js"
export * from "./IcoSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports